module.exports = __webpack_public_path__ + "static/media/new-message.05b479bb.mp3";